/**
 * MapPin Icon Component
 *
 * MapPin icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/map-pin-icon
 */
import { createIconNode } from '../create-icon';
const MAP_PIN_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [
            { d: 'M7.99999 9.50002C9.65684 9.50002 11 8.15688 11 6.50002C11 4.84317 9.65684 3.50002 7.99999 3.50002C6.34314 3.50002 4.99999 4.84317 4.99999 6.50002C4.99999 8.15688 6.34314 9.50002 7.99999 9.50002Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M13.2 6.5C13.2 11 8.00001 14.5 8.00001 14.5C8.00001 14.5 2.80005 11 2.80005 6.5C2.80005 3.23333 5.64881 1.5 8.00001 1.5C10.3512 1.5 13.2 3.23333 13.2 6.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [
            { d: 'M12 13.5C13.6568 13.5 15 12.1568 15 10.5C15 8.84313 13.6568 7.49999 12 7.49999C10.3431 7.49999 8.99997 8.84313 8.99997 10.5C8.99997 12.1568 10.3431 13.5 12 13.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M18 10.2692C18 15.4615 12 19.5 12 19.5C12 19.5 6 15.4615 6 10.2692C6 6.5 9.28703 4.5 12 4.5C14.7129 4.5 18 6.5 18 10.2692Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
});
export function MapPinIcon(props) {
    return createIconNode(MAP_PIN_ICON, props);
}
//# sourceMappingURL=map-pin.js.map